import { Image, Video } from '../CarouselBanner.types';

export const isImage = (media: Video | Image): media is Image => {
    return 'image' in media;
};
